const PERMISSIONS = {
  // --------------- 创作平台开始 --------------- //
  "创作平台-文章发布": [
    { actionName: "查看", key: "create-article-view" },
    { actionName: "添加", key: "create-article-create" },
    { actionName: "编辑信息", key: "create-article-update-info" },
    { actionName: "编辑详情", key: "create-article-update-detail" },
    { actionName: "评论", key: "create-article-comment" },
    { actionName: "显示/隐藏", key: "create-article-showstate" },
    { actionName: "撤稿", key: "create-article-cancel" },
    // { actionName: "免审发布", key: "create-article-publish" },
    {
      actionName: "提交审核/撤销审核/驳回原因",
      key: "create-article-review",
    },
    { actionName: "移除", key: "create-article-delete" },
  ],
  "创作平台-视频发布": [
    { actionName: "查看", key: "create-video-view" },
    { actionName: "添加", key: "create-video-create" },
    { actionName: "编辑信息", key: "create-video-update-info" },
    { actionName: "编辑详情", key: "create-video-update-detail" },
    { actionName: "评论", key: "create-video-comment" },
    { actionName: "显示/隐藏", key: "create-video-showstate" },
    { actionName: "撤稿", key: "create-video-cancel" },
    // { actionName: "免审发布", key: "create-video-publish" },
    {
      actionName: "提交审核/撤销审核/驳回原因",
      key: "create-video-review",
    },
    { actionName: "移除", key: "create-video-delete" },
  ],
  // --------------- 问答管理 --------------- //
  "创作平台-问卷管理": [
    { actionName: "查看", key: "question-qa-view" },
    { actionName: "添加", key: "question-qa-create" },
    { actionName: "编辑", key: "question-qa-update" },
    { actionName: "成绩数据", key: "question-qa-score" },
    { actionName: "显示/隐藏", key: "question-qa-state" },
    { actionName: "移除", key: "question-qa-delete" },
  ],
  "创作平台-题库管理": [
    { actionName: "查看", key: "question-bank-view" },
    { actionName: "添加", key: "question-bank-create" },
    { actionName: "编辑", key: "question-bank-update" },
    { actionName: "显示/隐藏", key: "question-bank-state" },
    { actionName: "移除", key: "question-bank-delete" },
  ],
  "创作平台-媒体号管理": [
    { actionName: "查看", key: "create-media-view" },
    { actionName: "编辑", key: "create-media-update" },
  ],
  "创作平台-运营活动管理": [{ actionName: "编辑", key: "create-cdp-view" }],
  媒体资源库管理: [
    { actionName: "查看", key: "create-mediaLibrary-view" },
    { actionName: "添加", key: "create-mediaLibrary-add" },
  ],
  "创作平台-角色管理": [
    { actionName: "查看", key: "create-role-view" },
    { actionName: "添加", key: "create-role-create" },
    { actionName: "编辑", key: "create-role-update" },
    { actionName: "移除", key: "create-role-delete" },
  ],
  "创作平台-圈子管理": [
    { actionName: "查看", key: "create-circle-view" },
    { actionName: "添加", key: "create-circle-create" },
    { actionName: "编辑", key: "create-circle-update" },
    { actionName: "移除", key: "create-circle-delete" },
    { actionName: "显示/隐藏", key: "create-circle-state" },
    { actionName: "内容管理", key: "create-circle-content" },
  ],
  "创作平台-运营人员管理": [
    { actionName: "查看", key: "create-operator-view" },
    { actionName: "添加", key: "create-operator-create" },
    { actionName: "编辑", key: "create-operator-update" },
    { actionName: "移除", key: "create-operator-delete" },
    { actionName: "启用/禁用", key: "create-operator-state" },
  ],
  "创作平台-圈子评论管理": [
    { actionName: "查看", key: "create-circleComment-view" },
    { actionName: "添加", key: "create-circleComment-create" },
    { actionName: "编辑", key: "create-circleComment-update" },
    { actionName: "移除", key: "create-circleComment-delete" },
  ],
  "创作平台-用户中心": [
    { actionName: "查看", key: "create-user-view" },
    // { actionName: "添加", key: "create-user-create" },
    { actionName: "编辑", key: "create-user-update" },
    { actionName: "移除", key: "create-user-delete" },
  ],
  // --------------- 创作平台结束 --------------- //
  // 话题管理
  "话题-列表": [
    { actionName: "查看", key: "topic-view" },
    { actionName: "添加", key: "topic-create" },
    { actionName: "编辑", key: "topic-update" },
    { actionName: "移除", key: "topic-delete" },
    { actionName: "内容管理", key: "topic-comment" },
    { actionName: "显示/隐藏", key: "topic-state" },
  ],
  "话题-内容管理": [
    { actionName: "查看", key: "topicContent-view" },
    { actionName: "编辑", key: "topicContent-update" },
    { actionName: "回复", key: "topicContent-reply" },
    { actionName: "置顶/取消置顶", key: "topicContent-top" },
  ],
  "话题-回复": [
    { actionName: "查看", key: "topicReply-view" },
    { actionName: "添加", key: "topicReply-create" },
    { actionName: "编辑", key: "topicReply-update" },
    { actionName: "移除", key: "topicReply-delete" },
    { actionName: "入库", key: "topicReply-storage" },
  ],
  数据看板: [{ actionName: "查看", key: "create-dashboard-view" }],
};

export { PERMISSIONS };
